"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createServerApolloClient;
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
var _client = require("@apollo/client");
var _persistedQueries = require("@apollo/client/link/persisted-queries");
var _sha2 = _interopRequireDefault(require("crypto-js/sha256"));
var _excluded = ["credentials", "headers"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DEFAULT_TARGET_PATH = 'default';
var apqLink = (0, _persistedQueries.createPersistedQueryLink)({
  sha256: function sha256(input) {
    return (0, _sha2.default)(input).toString();
  },
  useGETForHashedQueries: true
});
function createServerApolloClient(_ref) {
  var req = _ref.req,
    host = _ref.host,
    path = _ref.path,
    possibleTypes = _ref.possibleTypes,
    metadata = _ref.metadata,
    _ref$logger = _ref.logger,
    logger = _ref$logger === void 0 ? console : _ref$logger,
    _ref$linkOptions = _ref.linkOptions,
    linkOptions = _ref$linkOptions === void 0 ? {} : _ref$linkOptions,
    apqEnabled = _ref.apqEnabled,
    customLinks = _ref.customLinks,
    _ref$availableLoggedO = _ref.availableLoggedOutPaths,
    availableLoggedOutPaths = _ref$availableLoggedO === void 0 ? [] : _ref$availableLoggedO;
  var _linkOptions$credenti = linkOptions.credentials,
    credentials = _linkOptions$credenti === void 0 ? 'include' : _linkOptions$credenti,
    _linkOptions$headers = linkOptions.headers,
    headers = _linkOptions$headers === void 0 ? {} : _linkOptions$headers,
    otherLinkOptions = _objectWithoutProperties(linkOptions, _excluded);
  var appName = metadata.appName,
    appVersion = metadata.appVersion;

  // do not move outside of this scope.
  var apolloLinkMemoizeCache = {};
  function apolloLinkFactory() {
    var _req$header, _req$id;
    var targetPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TARGET_PATH;
    if (apolloLinkMemoizeCache[targetPath]) {
      return apolloLinkMemoizeCache[targetPath];
    }
    // Get the override headers from the request
    var smOverrideHeaders = req.headers ? Object.keys(req.headers).reduce(function (acc, key) {
      /**
       * Extract the custom headers 'x-sm-intercept-id', 'x-sm-pod-override-<service_name>'
       * to GraphAPI; they are used for mirrord (local development) and private pod overrides.
       */
      if ('x-sm-intercept-id' === key || /^x-sm-pod-override-/.test(key)) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, req.header(key)));
      }
      return acc;
    }, {}) : {};

    // if the targetPath is not the default one, use an alternate graphql endpoint.
    var uri = "".concat(host).concat(targetPath);
    var link = (0, _client.createHttpLink)(_objectSpread(_objectSpread({}, otherLinkOptions), {}, {
      uri: uri,
      credentials: credentials,
      headers: _objectSpread(_objectSpread({
        cookie: (_req$header = req.header('Cookie')) !== null && _req$header !== void 0 ? _req$header : '',
        // pass the requestId along with SSR requests to associate
        // render with it's graph requests
        'sm-request-id': (_req$id = req.id) !== null && _req$id !== void 0 ? _req$id : ''
      }, smOverrideHeaders), headers),
      fetch: _isomorphicFetch.default
    }));
    if (apqEnabled) {
      link = apqLink.concat(link);
    }
    apolloLinkMemoizeCache[targetPath] = link;
    return link;
  }

  // custom apollo-link that determines the actual link to use based on the passed
  // `targetPath` context.
  var link = (0, _client.from)([].concat(_toConsumableArray(customLinks || []), [new _client.ApolloLink(function (operation) {
    var targetPath = getTargetPath(operation);
    return apolloLinkFactory(targetPath).request(operation) || _client.Observable.of();
  })]));
  var getTargetPath = function getTargetPath(operation) {
    var _operation$getContext;
    var targetPath = operation === null || operation === void 0 || (_operation$getContext = operation.getContext) === null || _operation$getContext === void 0 || (_operation$getContext = _operation$getContext.call(operation)) === null || _operation$getContext === void 0 ? void 0 : _operation$getContext.targetPath;
    var graphQLPath = path;
    if (availableLoggedOutPaths.includes(targetPath)) {
      // whitelist for security
      graphQLPath = targetPath;
    }
    return graphQLPath;
  };

  // Logging middleware for GraphQL operations. Typically called
  // after the operation completed.
  var loggingMiddleware = new _client.ApolloLink(function (operation, forward) {
    var now = new Date();
    var targetPath = getTargetPath(operation);
    return forward(operation).map(function (result) {
      var then = new Date();
      logger.info({
        path: targetPath,
        operation: operation.operationName,
        ms: then.getTime() - now.getTime()
      }, 'graphql-fetch');
      return result;
    });
  });
  var cache = new _client.InMemoryCache({
    possibleTypes: possibleTypes
  });
  return new _client.ApolloClient({
    ssrMode: true,
    link: (0, _client.concat)(loggingMiddleware, link),
    cache: cache,
    name: appName,
    version: appVersion
  });
}
module.exports = exports.default;
//# sourceMappingURL=server.js.map